module.exports = __webpack_public_path__ + "static/img/erweima1.0.2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erweima1.0.2.jpg
// module id = LgTV
// module chunks = 75